"use client";

import { motion } from "framer-motion";
import { ArrowRight, Sparkles } from "lucide-react";
import Link from "next/link";

const CTA = () => {
  return (
    <section className="py-16 sm:py-20 relative overflow-hidden bg-[#fafafa]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="relative rounded-[3rem] overflow-hidden bg-black py-3 px-10 text-center"
        >
          {/* Animated Background Shapes */}
          <motion.div
            animate={{ 
              scale: [1, 1.2, 1],
              opacity: [0.1, 0.2, 0.1],
              rotate: [0, 90, 0]
            }}
            transition={{ duration: 15, repeat: Infinity, ease: "linear" }}
            className="absolute -top-1/2 -left-1/4 w-[600px] h-[600px] bg-gold/30 rounded-full blur-[100px]"
          />
          <motion.div
            animate={{ 
              scale: [1, 1.3, 1],
              opacity: [0.1, 0.15, 0.1],
              rotate: [0, -90, 0]
            }}
            transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
            className="absolute -bottom-1/2 -right-1/4 w-[700px] h-[700px] bg-gold/20 rounded-full blur-[120px]"
          />

          <div className="relative z-10 max-w-3xl mx-auto py-3">
           

            <h1 
              className="font-bold text-white mb-4 leading-tight"
              style={{ 
                fontSize: "clamp(28px, 5vw, 48px)",
                fontWeight: "700",
                lineHeight: "1.3"
              }}
            >
              Ready to Expand Your <br />
              <span className="text-gradient-gold">Global Footprint?</span>
            </h1>

            <p 
              className="text-white mb-12 max-w-xl mx-auto opacity-85"
              style={{ 
                fontSize: "clamp(14px, 1.2vw, 16px)",
                lineHeight: "1.6"
              }}
            >
              Join 1500+ successful entrepreneurs who have scaled their businesses globally with our premium consultancy.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
              <Link
                href="#contact"
                className="w-full sm:w-auto px-10 py-3 rounded-full gold-gradient text-white font-bold flex items-center justify-center gap-3 gold-glow hover:scale-105 active:scale-95 transition-all duration-300 shadow-2xl"
              >
                Start Your Visa Process <ArrowRight size={20} />
              </Link>
              <Link
                href="#services"
                className="w-full sm:w-auto px-10 py-3 rounded-full bg-white/5 border border-white/10 backdrop-blur-md text-white font-bold hover:bg-white/10 transition-colors"
              >
                View Documentation
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;
